<app-spinner></app-spinner>
<img class="buonny-logo-bg" src="assets/img/buonnylogo.png">
<img class="gpa-logo-bg" src="assets/img/logo-gpa.png">

<div class="card form">
    <div *ngIf="error.showAlert" class="alert" [class]="error.classAlert" role="alert">
        <button type="button" class="btn-close float-end" aria-label="Close" (click)="closeAlert()"></button>
        <h4 class="alert-heading">{{error.alertTitle}}</h4>
        <p>{{error.alertMessage}}</p>
    </div>
    <div class="card-body">
      <div class="row id-hash-container" *ngIf="hash$ | async">
        <span class="id-hash" title="{{hash$ | async}}"><strong>ID:</strong> {{hash$ | async}}</span>
      </div>
        
        <div class="breadcrumb-container" *ngIf="displayComponents.progress">
          <div class="timeline-container space-flex">
            <div class="line"></div>
            <div class="pin" [ngClass]="{'progress': !(stageLogin$ | async), 'completed' : (stageLogin$ | async) }"></div>
            <div class="pin" [ngClass]="{'progress': (stageLogin$ | async) && !(stageViagem$ | async), 'completed' : (stageViagem$ | async) }"></div>
            <div class="pin" [ngClass]="{'progress': (stageViagem$ | async) && !(stageVeiculo$ | async), 'completed' : (stageVeiculo$ | async) }"></div>
          </div>
          <div class="icons-container space-flex">
            <fa-icon [icon]="['fas', 'user']" size="2x"></fa-icon>
            <fa-icon [icon]="['fas', 'map']" size="2x"></fa-icon>
            <fa-icon [icon]="['fas', 'truck']" size="2x"></fa-icon>
          </div>
        </div>

        <div class="row" *ngIf="displayComponents.title">
            <span class="text-center title" translate>preCheckout.title</span>
        </div>

        <div *ngIf="error.tentativa==3" class="text-center text-danger" style="padding: 50px 0px 0px 0px;">
          Você excedeu o limite de {{error.tentativa}} tentativas!<br/>
          Tentar novamente em {{millisecondsToTime(timeLeft)}}
        </div>

        <div style="margin: 0px 0px 30px 0px;">
          <div class="container">
            <div class="row">
              <div class="col-sm" *ngIf="cpf$ | async">
                <span class="font-bold">CPF: </span>{{formataCPF(cpf$ | async)}}<br/>
              </div>
              <div class="col-sm" *ngIf="name$ | async">
                <span class="font-bold">Nome: </span>{{name$ | async}}<br/>
              </div>
            </div>
            <div class="row">
              <div class="col-sm" *ngIf="phone$ | async">
                <span class="font-bold">Cel.: </span>{{formataCelularDDD(phone$ | async)}}<br/>
              </div>
            </div>
            <div class="row">
              <div class="col-sm" *ngIf="route$ | async">
                <span class="font-bold">Rota: </span>{{route$ | async}}<br/>
              </div>
              <div class="col-sm" *ngIf="sm$ | async">
                <span class="font-bold">SM: </span>{{sm$ | async}}<br/>
              </div>
            </div>
            <div class="row">
              <div class="col-sm" *ngIf="originCd$ | async">
                <span class="font-bold">CD de origem: </span>{{originCd$ | async}}<br/>
              </div>
            </div>
            <div class="row">
              <div class="col-sm" *ngIf="destinoCd$ | async">
                <span class="font-bold">CD de destino: </span>{{destinoCd$ | async}}<br/>
              </div>
            </div>
            <div class="row">
              <div class="col-sm" *ngIf="transporter$ | async">
                <span class="font-bold">Transportadora: </span>{{transporter$ | async}}<br/>
              </div>
            </div>
            <div class="row">
              <div class="col-sm" *ngIf="transporterType$ | async">
                <span class="font-bold">Tipo de transporte: </span>{{transporterType$ | async}}<br/>
              </div>
            </div>
          </div>

          <table class="table" *ngIf="(plates$ | async).length">
            <thead>
              <tr>
                <th scope="col">Placa</th>
                <th scope="col">Tipo</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of (plates$ | async)" [hidden]="!item?.placa">
                <td>{{item?.placa}}</td>
                <td>{{item?.tipo}}</td>
              </tr>
            </tbody>
          </table>
          
        </div>

        <router-outlet></router-outlet>

        <hr/>

        <div class="container footer-container">
            <div class="row">
              <div class="col-sm" *ngIf="displayComponents.buttonHelp">
                <fa-icon [icon]="['fas', 'question-circle']" size="2x"></fa-icon>
              </div>
              <div class="col-auto text-center">
                {{clock}}
                <div *ngIf="displayComponents.buttonModalChecklist">
                  <span id="linkConsultaChecklist" class="link-primary" style="cursor: pointer;" (click)="consultaChecklist()">Consultar Checklist</span>
                </div>
              </div>
              <div class="col-sm" *ngIf="displayComponents.buttonExit" (click)="exit()">
                <fa-icon class="float-end" [icon]="['fas', 'sign-out-alt']" size="2x"></fa-icon>
              </div>
            </div>
        </div>

    </div>
</div>

<app-modal #modalExit [(modalConfig)]="modalConfig">
  <span style="color: red;">Deseja realmente abortar o processo?</span>
</app-modal>

<app-modal id="modalChecklist" #modalChecklist [(modalConfig)]="modalConfigChecklist">
  <app-pre-checkout-checklist #selectorChecklist></app-pre-checkout-checklist>
</app-modal>